'use client';
import { LicenseInfo } from '@mui/x-license';

LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_PRO_LICENSE);

export default function MuiXLicense() {
  return null;
}
